import { StatToolTip } from '../../InteractiveMap/toolTip';
import { Circle, ICircleCreationEvent } from '../edit/circle';
import { ETool } from './Etool';
import { EraserTool, IToolStrategy, PenTool, ViewOnlyTool } from './tool';

class ToolProvider {
    private tools: Map<ETool, IToolStrategy>;
    private selectedTool: ETool;
    private selectedCircle: Circle | undefined;
    private static instance: ToolProvider | undefined;

    private constructor(tooltip: StatToolTip, creationEvent: ICircleCreationEvent, hoverReset: () => void) {
        this.tools = new Map([
            [ETool.Eraser, new EraserTool()],
            [ETool.Pen, new PenTool(Circle.colors.blue, creationEvent)],
            [ETool.View, new ViewOnlyTool(tooltip, hoverReset)]
        ]);
        this.selectedTool = ETool.View;
    }

    set(tool: ETool) {
        this.selectedTool = tool;
    }

    get tool() {
        return this.tools.get(this.selectedTool);
    }

    get toolType() {
        return this.selectedTool;
    }

    getTarget() {
        return this.selectedCircle;
    }

    setTarget(target: Circle) {
        this.selectedCircle = target;
    }

    public static CreateInstance(tooltip: StatToolTip, creationEvent: ICircleCreationEvent, hoverReset: () => void) {
        this.instance = new ToolProvider(tooltip, creationEvent, hoverReset);
        return this.instance;
    }

    public static GetInstance() {
        return this.instance;
    }
}

export default ToolProvider;
